var _g, _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 48,
    viewBox: "0 0 92 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p1bq454k8a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.869 44c5.45 0 9.869-4.477 9.869-10s-4.419-10-9.87-10C10.419 24 6 28.477 6 34s4.418 10 9.869 10z",
    fill: "#EE0005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.13 44C33.582 44 38 39.523 38 34s-4.419-10-9.87-10c-5.45 0-9.868 4.477-9.868 10s4.418 10 9.869 10z",
    fill: "#F9A000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.262 34a10.094 10.094 0 0 0 .981 4.353A9.96 9.96 0 0 0 22 41.837a9.977 9.977 0 0 0 2.754-3.484 10.11 10.11 0 0 0 0-8.704A9.977 9.977 0 0 0 22 26.164a9.96 9.96 0 0 0-2.756 3.483A10.094 10.094 0 0 0 18.262 34z",
    fill: "#FF6300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.985 5-2.208 13.98h3.53L21.514 5h-3.529zm10.648 5.692c-1.233-.62-1.99-1.038-1.99-1.67.016-.577.64-1.167 2.035-1.167.903-.027 1.8.15 2.628.516l.321.146.48-2.924a8.777 8.777 0 0 0-3.168-.575c-3.485 0-5.94 1.843-5.955 4.477-.028 1.945 1.753 3.024 3.1 3.672 1.366.665 1.83 1.096 1.83 1.684-.014.906-1.103 1.324-2.12 1.324a7.078 7.078 0 0 1-3.311-.72l-.465-.214-.493 3.038a10.86 10.86 0 0 0 3.937.72c3.704 0 6.114-1.814 6.145-4.623.001-1.54-.941-2.72-2.975-3.684h.001zm12.522-5.648h-2.732a1.729 1.729 0 0 0-1.112.24 1.774 1.774 0 0 0-.733.884l-5.244 12.804h3.704l1.02-2.772h4.146l.53 2.783H44l-2.846-13.94zm-4.066 8.36c.071.007 1.422-4.523 1.422-4.523l1.078 4.523h-2.5zM12.827 5.001l-3.459 9.494-.376-1.872a10.38 10.38 0 0 0-4.88-5.674L7.276 18.96h3.735l5.551-13.959H12.827z",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83 6.8a2.349 2.349 0 0 0-.834-1.31A2.281 2.281 0 0 0 5.538 5H.057L0 5.26a13.357 13.357 0 0 1 5.346 2.689 13.639 13.639 0 0 1 3.675 4.776L7.83 6.8z",
    fill: "#F7981D"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 8,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#553B8A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.561 20.713a7.36 7.36 0 0 0-4.726-6.833c-.913-.352-1.95-.552-3.101-.552h-6.459v3.754h6.36c.458 0 .88.057 1.264.16 1.95.52 2.954 2.208 2.954 3.52 0 1.313-1.004 2.999-2.954 3.52-.384.104-.804.161-1.264.161H63.88a1.877 1.877 0 1 0 0 3.754h6.855c1.153 0 2.19-.2 3.101-.552a7.357 7.357 0 0 0 4.726-6.833v-.099z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.047 13.336h-4.77v3.754h5.827v-3.754h-1.057z",
    fill: "#fff",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m75.968 31.342-2.131-3.7-1.936-3.361-4.147-7.2-1.524-2.645a2.212 2.212 0 0 0-1.857-1.108h-.127a2.21 2.21 0 0 0-1.851 3.318l4.49 7.796 2.162 3.753 3.086 5.358a2.215 2.215 0 0 0 3.836-2.21h-.001z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m75.966 31.342-2.13-3.7-1.937-3.361-4.146-7.2-1.525-2.645a2.212 2.212 0 0 0-1.856-1.108h-.127a2.232 2.232 0 0 0-.495.071c.36.188.672.478.891.856l1.524 2.646 4.147 7.198 1.936 3.363 2.13 3.699a2.215 2.215 0 0 1-1.356 3.247 2.215 2.215 0 0 0 2.946-3.066h-.002z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.88 24.438h-3.003a1.877 1.877 0 1 0 0 3.753h5.164l-2.161-3.753z",
    fill: "#fff",
    opacity: 0.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m71.898 24.282 1.937 3.363a7.34 7.34 0 0 0 3.147-2.314l-2.509-3.097a4.02 4.02 0 0 1-2.575 2.048z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "p1bq454k8a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v48H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon);
export default __webpack_public_path__ + "static/media/creditCardIcon.ab960df0edf4a16f454bb334972779b8.svg";
export { ForwardRef as ReactComponent };